import { ModIconButton } from '@moderneinc/design-system-components';
import type { FunctionComponent } from 'react';
import {
  OrganizationSelectorGridDocument,
  type OrganizationSelectorGridQueryVariables
} from '../../__generated__/apollo-hooks';
import { GraphQLIcon } from '../../icons/icons';
import { SeeHowToRunGraphQL } from '../graphql-explorer/see-how-to-run-graphql.component';

export const OrganizationsApiExample: FunctionComponent = () => {
  return (
    <SeeHowToRunGraphQL<OrganizationSelectorGridQueryVariables>
      examples={[
        {
          label: 'Organizations',
          operationDocument: OrganizationSelectorGridDocument,
          operationVariables: {}
        }
      ]}
      slots={{
        button: (
          <ModIconButton
            size="small"
            aria-label="API examples"
            title="View API example: Organizations"
          >
            <GraphQLIcon />
          </ModIconButton>
        )
      }}
    />
  );
};
